import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  open: boolean;
  title: string;
  /** 本文（複数行は配列で渡す） */
  messages: string[];
  confirmLabel: string;
  /** confirm ボタンの色（削除は error 等） */
  confirmColor?: 'primary' | 'error';
  submitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

/**
 * 削除 / リバート等の確認ダイアログ（共通）。
 */
const ConfirmDialog: React.FC<Props> = ({
  open,
  title,
  messages,
  confirmLabel,
  confirmColor = 'primary',
  submitting,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: {
          elevation: 0,
          sx: { borderRadius: 3, border: 1, borderColor: 'divider' },
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={0.5}>
          {messages.map((m, i) => (
            <Typography key={i} variant="body2" color="text.secondary">
              {m}
            </Typography>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          キャンセル
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          onClick={onConfirm}
          disabled={submitting}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
